import { useQuery } from "react-query";
import apiService from "services/api";
import moment from "moment";
import { CustomTable } from "components";

const transactionColumns = [
	{
		id: "transactionDate",
		Header: "Transaction Date",
		accessor: (row) => {
			return moment(row.createdAt).format("YYYY-MM-DD, HH:MM");
		},
		sortable: true,
		sortType: (a, b) => {
			return new Date(b.original.createdAt) - new Date(a.original.createdAt);
		},
		filterable: true,
	},
	{
		id: "userID",
		Header: "Member ID",
		accessor: "userId",
		sortable: true,
		filterable: true,
	},
	{
		id: "orderNumber",
		Header: "Order Number",
		accessor: (row) => row.order.orderNumber,
		sortable: true,
		filterable: true,
	},
	{
		id: "userName",
		Header: "Member Name",
		accessor: (row) => row.user.firstName + " " + row.user.lastName,
		sortable: true,
		filterable: true,
	},
	{
		id: "itemsOrdered",
		Header: "Items Ordered",
		accessor: "menuItemName",
		sortable: true,
		filterable: true,
	},
	{
		id: "quantity",
		Header: "Quantity",
		accessor: (row) => {
			return row.quantity;
		},
		sortable: true,
	},
	{
		id: "totalAmount",
		Header: "Total Amount",
		accessor: (row) => {
			if (isNaN(parseFloat(row.totalTransactionPrice))) return parseInt(row.menuItem?.price) * parseInt(row.quantity);
			return parseFloat(row.totalTransactionPrice).toFixed(2);
		},
		sortable: false,
		filterable: false,
	},
];

const CoffeeTransactionsPage = () => {
	const { data: transactions, isLoading } = useQuery("transaction", () => apiService.getTransactions());

	return (
		// Endpoint is Transaction
		<div className="content">
			<CustomTable data={transactions} loading={isLoading} columns={transactionColumns} title="Coffee Transactions" />
		</div>
	);
};

export default CoffeeTransactionsPage;
